class HeroSlider {
  constructor(el) {
    this.el = el;
    this.slides = Array.from(el.querySelectorAll('.hero-slide'));
    this.dots = Array.from(el.querySelectorAll('.hero-slider__dot'));
    this.prevBtn = el.querySelector('.hero-slider__arrow--prev');
    this.nextBtn = el.querySelector('.hero-slider__arrow--next');
    this.current = 0;
    this.autoplaySpeed = parseInt(el.dataset.autoplaySpeed || '0', 10);
    this.timer = null;

    if (this.slides.length <= 1) return;

    this.prevBtn && this.prevBtn.addEventListener('click', () => this.go(this.current - 1));
    this.nextBtn && this.nextBtn.addEventListener('click', () => this.go(this.current + 1));
    this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i)));

    this.el.addEventListener('mouseenter', () => this.stopAutoplay());
    this.el.addEventListener('mouseleave', () => this.startAutoplay());

    this.startAutoplay();
  }

  go(index) {
    const total = this.slides.length;
    this.current = (index + total) % total;
    this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === this.current));
    this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === this.current));
  }

  startAutoplay() {
    if (!this.autoplaySpeed) return;
    this.stopAutoplay();
    this.timer = setInterval(() => this.go(this.current + 1), this.autoplaySpeed * 1000);
  }

  stopAutoplay() {
    if (this.timer) clearInterval(this.timer);
  }
}

document.querySelectorAll('.hero-slider').forEach((el) => new HeroSlider(el));

if (Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const el = event.target.querySelector('.hero-slider');
    if (el) new HeroSlider(el);
  });
}